import updateCartViews from "./eCommerce";
export default class CartItem extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    getSelectorUpQuantity() {
        return '.plus';
    }

    getSelectorDownQuantity() {
        return '.minus';
    }

    getSelectorInputQuantity() {
        return "input[name='product-count']";
    }

    getElementInputQuantity() {
        return $( this.getSelectorInputQuantity() )
    }

    getSelectorRemoveCartLine() {
        return "button.order-item-card-remove";
    }

    getSelectorCartLine() {
        return '.order-item-card';
    }

    getSelectorChangeShippingMeans() {
        return "select[name='shipping_means']";
    }

    getSelectorChangePaymentMeans() {
        return "select[name='payment_means']";
    }

    getSelectorChooseAddress() {
        return 'a.choose-address';
    }

    getSelectorAddAddress() {
        return 'a.add-address';
    }

    getSelectorEditAddress() {
        return 'a.edit-address';
    }

    getSelectorResetCart() {
        return 'a#reset_cart';
    }

    getElementAddCodePromo() {
        return $(this.getSelectorValueCodePromo());
    }

    getElementCurrentCodePromo() {
        return $(this.getSelectorValueCurrentCodePromo());
    }

    getSelectorRemoveCodePromo() {
        return '#remove-promo';
    }

    getSelectorRemoveCodeBcp() {
        return '#remove-bcp';
    }

    getElementRemoveCodePromo() {
        return $(this.getSelectorRemoveCodePromo());
    }

    getElementRemoveCodeBcp() {
        return $(this.getSelectorRemoveCodeBcp());
    }

    getSelectorValueCodePromo() {
        return 'input[name="promocode"]';
    }

    getSelectorValueCurrentCodePromo() {
        return '#current_promo';
    }

    getSelectorApplyCodePromo() {
        return '.promo-code-apply';
    }

    getSelectorToggleFavorite () {
        return '.add-fav';
    }

    getAllCartTemplate () {
        return ['cart_weight','cart_right', 'cart_lines_list'];
    }

    getSelectorCheckboxCGV () {
        return '#accept_cgv';
    }

    getNoValideCodeElement() {
        return $('#no_valide_code');
    }

    getElementLoaderModal() {
        return $('.loading');
    }

    getSelectorCartValidation() {
        return '#cart-validate';
    }

    /* Init all cart events */
    events() {
        $('.page-basket').on('click','.btn-close',function(e){
            $('#modal').modal('hide');
        });

        $("#change_name").on('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            let a = $("#change_name");
            let cart_id = a.data( 'cart_id' );

            window.HegydCore.initRemoteModal(
                '#modal',
                a.prop('href'),
                function(){
                    $('#cart_id').val(cart_id);
                },
                (data) => {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        } else{

                            toastr.success(data.message);
                        }
                    } else{
                        toastr.success(data.message);
                    }

                    location.reload();
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });

        //Todo
        /* Sélection d'un mode de livraison */
        $(this.getSelectorChangeShippingMeans()).on('change', (e) => {
            this.selectDeliveryMode($(e.target));
        });

        /* Sélection d'un moyen de paiement */
        $(this.getSelectorChangePaymentMeans()).on('change', (e) => {
            this.selectPaymentMean($(e.target));
        });

        /* Choix d'une adresse */
        $(this.getSelectorChooseAddress()).on('click', (e) => {
            e.preventDefault();

            this.initCartAddressesModal($(e.target).closest( this.getSelectorChooseAddress() ).attr('href'));
        });

        /* Ajout d'une nouvelle adresse */
        $(this.getSelectorAddAddress()).on('click', (e) => {
            e.preventDefault();

            this.initCartAddressesModal($(e.target).closest( this.getSelectorAddAddress()).attr('href'), () => {
                this.initSelect2Countries();

                this.hideLoader();
            });
        });

        /* Edition d'une adresse */
        $(this.getSelectorEditAddress()).on('click', (e) => {
            e.preventDefault();

            this.initCartAddressesModal($(e.target).closest( this.getSelectorEditAddress()).attr('href'), () => {
                this.initSelect2Countries();

                this.hideLoader();
            });
        });

        /* Remise à zéro du panier */
        $(this.getSelectorResetCart()).on('click', (e) => {
            e.preventDefault();

            this.deleteCart($(e.target).closest(this.getSelectorResetCart()));
        });

        /* Validation des CGV */
        $(this.getSelectorCheckboxCGV()).on('change', (e) => {
            e.preventDefault();

            this.toggleValidationCGV($(e.target));
        });

        /* Ajout ou Suppression des favoris */
        $(this.getSelectorToggleFavorite()).on('click', (e) => {
            e.preventDefault();

            this.toggleFavoris($(e.target).closest(this.getSelectorToggleFavorite()));
        });

        /* Ajout d'un code promotion */
        $(this.getSelectorApplyCodePromo()).on('click', (e) => {
            e.preventDefault();

            this.applyCodePromo();
        });

        /* Suppression d'un code promotion */
        $(this.getSelectorRemoveCodePromo()).on('click', (e) => {
            e.preventDefault();

            this.removeCodePromo(e);
        });

        $(this.getSelectorRemoveCodeBcp()).on('click', (e) => {
            e.preventDefault();

            this.removeCodeBcp(e);
        });

        /* Modal Monetico */
        $(this.getSelectorCartValidation()).on('click', (e) => {
            if($(e.target).data('shipping_means')){
                e.preventDefault();

                HegydCore.initRemoteModal('#payment-several-time', $(this).attr('href'), function (){}, function (){}, function (){}, false);
            }

            e.preventDefault();
        });

        $('#reload_btn').on('click', (e) => {
            this.connectedCallback();
        });
    }

    hideLoader() {
        this.getElementLoaderModal().hide();
    }

    initPlugins() {
        this.connectedCallback();
    }

    reloadCart() {
        HegydCore.sendRequest( $('#cart_header').data('route_refresh'), 'GET', {
            'return_templates': this.getAllCartTemplate(),
        }, data => {
            this.updateCartViews(data);

            this.connectedCallback();
        });
    }

    updateCartIndexView(data) {
        this.updateCartViews(data);

        this.connectedCallback();

        swal.close();
    }

    updateCartIndexViewAfterDeleteAProduct(data) {
        this.updateCartViews(data);

        swal.close();
    }

    updateCartViews(data) {
        if (data.hasOwnProperty('templates')) {
            $.each(data.templates, (templateName, templateHtml) => {
                let $element = $('[data-cart-template="' + templateName + '"]', 'body');

                if ($element.length) {
                    $element.children().remove();
                    $element.append(templateHtml);

                    if ($('.undeliverableAddress').length) {
                        swal({
                            type: 'error',
                            title: '',
                            html: true,
                            text: $('.undeliverableAddress').html()
                        });
                    }
                } else if (templateName == 'cart-popup') {
                    toastr.success(templateHtml);
                } else if (templateName == 'cart-popup-html') {
                    $('[data-append-template="' + templateName + '"]')
                        .empty()
                        .append(templateHtml);
                }
            });
        }

        this.events();
    }

    initCartAddressesModal(url, loadedCallback) {
        HegydCore.initRemoteModal('#cart-modal', url, loadedCallback, ( data ) => {
            setTimeout(() => {
                this.updateCartViews(data);

                this.initPlugins();

                toastr.success( 'L\'adresse a été mise à jour !' );
            }, 300);
        });
    }

    askToDelete(deleteText, buttonText, cancelButtonText, callback) {
        swal({
            title: '',
            html: "<span style='color: #F17474;'>" + deleteText + "</span>",
            allowOutsideClick: true,
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: cancelButtonText,
            confirmButtonText: buttonText,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function ( resolve ) {
                    if ( callback ) {
                        callback( resolve );
                    }
                });
            }
        }).then(function () {
            swal.close();
        });
    }

    initSelect2Countries() {
        $('#country_id').select2({
            language: 'fr',
            ajax: {
                url: '/countries',
                data: function (params) {
                    return {
                        query: params.term
                    };
                },
                processResults: function (data) {
                    const results = [];

                    $.each(data, function (id, entity) {
                        results.push({
                            id: entity.id,
                            text: entity.title_fr
                        });
                    });

                    return {results: results};
                },
                templateResult: function (data) {
                    return data.title_fr;
                }
            },
            initSelection: function (element, callback) {
                const id = $('[name=address_country_id]').val();
                const results = [];

                if (id) {
                    $.ajax("/countries/" + id, {
                        dataType: "json"
                    }).done(function (entity) {
                        if (entity) {
                            const id = entity.id;
                            const text = entity.title_fr;

                            results.push({id: id, text: text});
                        }

                        callback(results);
                    });
                }

                callback(results);
            }
        });
    }

    deleteCart( $link_reset_cart ){
        this.askToDelete( $link_reset_cart.data( 'message' ), $link_reset_cart.data( 'btn_text' ), $link_reset_cart.data( 'cancel_btn_text' ), callback => {
            HegydCore.sendRequest( $link_reset_cart.attr( 'href' ), 'PUT', {
                'cart_id': $link_reset_cart.data( 'cart_id'),
                'return_templates': this.getAllCartTemplate(),
            }, ( data ) => {
                this.updateCartViews( data );
                this.initPlugins();

                location.reload();
            });
        });
    }

    selectDeliveryMode( $input_delivery_mode ) {
        HegydCore.sendRequest( $input_delivery_mode.data( 'route' ), 'PUT', {
            'shipping_means'        : $input_delivery_mode.val(),
            'update-cart'           : true,
            'return_templates'      : this.getAllCartTemplate(),
        }, ( data ) => {
            this.updateCartViews( data );

            this.initPlugins();
        });
    }

    selectPaymentMean( $select_payment_mean ) {
        HegydCore.sendRequest( $select_payment_mean.data('route'), 'PUT', {
            'payment_means'     : $select_payment_mean.val(),
            'update-cart'       : true,
            'return_templates'  : this.getAllCartTemplate(),
        }, ( data ) => {
            this.updateCartViews( data );

            this.initPlugins();
        });
    }

    toggleFavoris( $element ) {
        HegydCore.sendRequest( $element.attr('href'),'PUT', {}, ( data ) => {
            Kernel.factories.Toaster( $('html'), 'success', data.message )

            this.reloadCart();
        });
    }

    toggleValidationCGV( $element ) {
        HegydCore.sendRequest( $element.data('route'),'PUT', {
            'update-cart'       : true,
            'accept_cgv'        : $element.prop('checked') ? 1 : 0,
            'return_templates'  : this.getAllCartTemplate(),
        },  (data) => {
            this.updateCartIndexView(data);
        });
    }

    applyCodePromo() {
        const code = this.getElementAddCodePromo().val();

        if (code.length === 0) {
            this.getNoValideCodeElement().show();

            return false;
        }

        HegydCore.sendRequest( this.getElementAddCodePromo().data('route'), 'POST', {
            code: code,
            'cart_id': this.getElementAddCodePromo().data('cart_id'),
            return_templates: this.getAllCartTemplate()
        }, (data) => {
            if(data.hasOwnProperty('errors')){
                if(data.errors.length > 0){
                    toastr.error(data.errors);
                }
            } else {
                toastr.success( data.message );
            }

            this.updateCartViews( data );
        }, (data) => {
            this.getNoValideCodeElement().empty().html(data.responseJSON.text).show();
        });
    }

    checkCurrentPromo() {
        const code = this.getElementCurrentCodePromo().val();

        HegydCore.sendRequest( this.getElementAddCodePromo().data('route'), 'POST', {
            code: code,
            'cart_id': this.getElementAddCodePromo().data('cart_id'),
            return_templates: this.getAllCartTemplate()
        }, (data) => {
            if(data.hasOwnProperty('errors')){
                if(data.errors.length > 0){
                    this.removeCodePromo()
                }
            } else {
                toastr.success( data.message );

                this.updateCartViews( data );
            }
        }, (data) => {
            this.getNoValideCodeElement().empty().html(data.responseJSON.text).show();
        });
    }

    removeCodePromo(e) {
        HegydCore.sendRequest( this.getElementRemoveCodePromo().attr('href'), 'DELETE', {
            'cart_id': this.getElementRemoveCodePromo().data('cart_id'),
            return_templates: this.getAllCartTemplate()
        }, (data) => {
            toastr.success( data.message );

            this.updateCartViews( data );
        });
    }

    removeCodeBcp(e) {
        HegydCore.sendRequest( this.getElementRemoveCodeBcp().attr('href'), 'DELETE', {
            'cart_id': this.getElementRemoveCodeBcp().data('cart_id'),
            return_templates: this.getAllCartTemplate()
        }, (data) => {
            toastr.success( data.message );

            this.updateCartViews( data );
        });
    }
}